import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { Adempimento } from '../../../common/models/adempimento';
import { SearchAdempimentiResponse } from '../../../common/models/dto/search-adempimenti-response';
import { PropertiesSettings } from '../../configuration/properties-settings';
import { UrlSettingsCore } from '../../configuration/url-settings-core';
import { RefreshHeader } from '../../models/refresh-header';
import { OperationsService } from '../../services/operations.service';
import { ViewManagerService } from '../../services/view-manager-service';
import { AppData } from 'src/app/data-store';

@Component({
  selector: '[prossimi-adempimenti]',
  templateUrl: 'prossimi-adempimenti.component.html',
  styleUrls: ['./prossimi-adempimenti.component.css']
})

export class ProssimiAdempimentiComponent implements OnInit {
  show: boolean = true;
  adempimenti: Adempimento[] = [];
  numNotifiche: number = 0;
  polling: boolean = true;
  subscriptionProssimiAdempimenti: Subscription;
  viewAll: string = UrlSettingsCore.URL_PROSSIMI_ADEMPIMENTI;
  numToView: number = 5;
  @Output() onClick = new EventEmitter();
  constructor(private viewManager: ViewManagerService,
              protected operationService: OperationsService) {}

  ngOnInit() {

    this.subscriptionProssimiAdempimenti = this.viewManager.prossimiAdempimenti.subscribe(
      response => {
        this.refreshAdempimenti(response)
      }
    );
    if(!AppData.getInstance().prossimiAdempimenti) {
      this.loadProssimiAdempimenti();
    } else {
      this.prossimiAdempimentiListResult(AppData.getInstance().prossimiAdempimenti)
    }

    /*
      let model = this;
      setTimeout(
        function() { if (model) { model.loadProssimiAdempimenti(true); } },
        180000
      );
    */

  }

  private refreshAdempimenti(response?: RefreshHeader) {

    this.adempimenti = [];
    if( response && response.param){

      //console.info("refreshAdempimenti : ", response.param)

      this.prossimiAdempimentiListResult(response.param)
    }else{
      this.loadProssimiAdempimenti(response ? response.timeOut : false);
    }

  }

  private loadProssimiAdempimenti(timeOut: boolean = false) {

    if (this.polling) {
      this.operationService.getProssimiAdempimenti({fromResult: this.adempimenti.length}).
        subscribe(response => {
          AppData.getInstance().prossimiAdempimenti = response;
          //console.info("loadProssimiAdempimenti : "+timeOut, response)

          this.prossimiAdempimentiListResult(response);
          if(timeOut){
            this.viewManager._adempimentiInevasi.next({param: null, timeOut: timeOut});
          }

        });
    }

  }

  private prossimiAdempimentiListResult(response: SearchAdempimentiResponse) {
    AppData.getInstance().prossimiAdempimenti = response;
    if (response && response.adempimenti && response.adempimenti.length > 0) {
      let responseAdempimenti = response.adempimenti;
      let dataDal = new Date().valueOf(); // today
      let dataAl = new Date((new Date()).getTime() + 7 * 24 * 60 * 60 * 1000).valueOf(); // today + 7
      responseAdempimenti = responseAdempimenti.filter((a: Adempimento) => a.dataScadenza >= dataDal && a.dataScadenza <= dataAl);
      this.adempimenti = this.adempimenti.concat(responseAdempimenti);
      this.numNotifiche = response.setNumeroAdempimentiTotali;
    }
  }

  ngOnDestroy() {
    this.polling = false;
    this.subscriptionProssimiAdempimenti
      && this.subscriptionProssimiAdempimenti.unsubscribe();
  }

  getAriaLabel() {
    if(this.adempimenti.length > 0) {
      return "Sono presenti " + this.adempimenti.length + " " + "prossimi adempimenti";
    } else {
      return "Non ci sono adempimenti nei prossimi 7 giorni";
    }
  }

}
